<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Prize Draw')}}</div>
        </div>
        <div class="wrap">
            <div class="mt-20">
                <!--翻牌子机会数-->
                <div class="title mb-20">{{$t('Free Draw Chances')}}:<label id="count">{{ drawNum }}</label></div>

                <div class="box">
                    <div v-for="(item,index) in list" :key="index" class="item">
                        <div @click="itemClick(item,index)">
                            <div :class="['card1', (item.status > 0 ? 'hide' : ''), (item.clicking ? 'card-click' : '')]">
                                <template>
                                    <img :src="require(`@/assets/images/four/${index + 1}.png`)"  class="prize-img" />
                                </template>
                            </div>

                            <div
                                    :class="{
                                  'card2 show': item.status === 1,
                                  'card2': item.status === 0,
                                  'card2 show-result': item.status === 2
                                }"
                            >
                                <template>
                                    <div class="pd-lr-5">
                                        <div class="prizeimg"><img :src="item.logo"/></div>
                                        <div class="mt-5">{{ item.name }}</div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 抽奖规则 -->
                <div  class="illustrate">
                    <div>{{ $t("lucky_draw.rulesTitle") }}</div>

                    <div style="margin-top:20px; text-align:left;">
                        <p>{{$t('lucky_draw.rulesInfo1')}}</p>
                        <p>{{$t('lucky_draw.rulesInfo2')}}</p>
                        <p>{{$t('lucky_draw.rulesInfo3')}}</p>
                        <p>{{ $t("lucky_draw.rulesInfo4") }}</p>
                    </div>

                </div>
            </div>
        </div>

        <!-- 加载抽奖记录 -->
        <div class="return-back1">
            <div class="back-right" @click="drawRecord">{{$t('lucky_draw.record')}}</div>
        </div>
        <van-action-sheet v-model="showRecord" :title="$t('Lottery Records')">
            <div class="content">
                <div class="border-common"></div>
                <div class="mt-10">
                    <van-cell v-for="item in drawRecordList" :key="item.id" :title="item.name" :value="item.add_time" />
                </div>
                <div class="mt-30"></div>
            </div>
        </van-action-sheet>

    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "chipLottery",
        data() {
            return {
                drawNum: 0,
                list: [], // 奖品列表
                money: 0,
                drawId: 0, // 中奖的奖品ID 用来计算转盘索引的
                drawTitle: '', // 中奖的奖品标题 后端自动适配国际化
                rewardNum: 0, // 抽中的奖品数量或者说 金额
                showRecord: false, // 是否显示抽奖记录
                drawRecordList: [], // 中奖记录
            };
        },
        created() {
            // 隐藏底部菜单
            this.$parent.footer('index', false);
            // 打乱顺序
            this.list.sort(() => Math.random() - 0.5);
            this.init();
        },
        methods: {
            init() {
                // 获取奖品列表
                Fetch('/shard_lucky_draw', { }).then((r) => {
                    this.list = r.data.prizelist.map((it) => ({
                        ...it,
                        status: 0, // 0:未翻牌 1:已中奖牌 2:其他翻开
                        clicking: false,
                    }));
                    this.drawNum = r.data.luckynum; // 可用抽奖次数
                    this.money   = r.data.money; // 可用余额
                });
            },
            // 点击翻牌
            async itemClick(item, index) {
                if (this.drawNum <= 0) return;

                // 给卡片加点击动画
                this.$set(item, 'clicking', true);

                await Fetch('/shard_lucky_draw/get_lucky_result?type=2', { }).then((r) => {
                    this.drawNum = r.data.luckynum; // 设置可用抽奖次数
                    this.drawId = r.data.drawId; // 设置获得的奖品ID
                    this.drawTitle = r.data.title; // 中奖标题
                    this.money = r.data.money; // 用户剩余金额
                    this.rewardNum = r.data.reward_num; // 抽中的奖品数量

                    const winIndex = this.list.findIndex(it => Number(it.id) === this.drawId);

                    // 动画结束后翻牌
                    setTimeout(() => {
                        // 把“中奖项”与“用户点击项”交换位置，这样点击的那张就是中奖的
                        if (winIndex !== -1 && winIndex !== index) {
                            const tmp = this.list[index];
                            this.$set(this.list, index, this.list[winIndex]);
                            this.$set(this.list, winIndex, tmp);
                        }

                        // 现在点击位就是中奖卡
                        const clicked = this.list[index];
                        clicked.status = 1;
                        clicked.flipped = true;
                        this.$set(item, 'clicking', false); // 移除点击动画类

                        // 翻开剩余的卡片
                        setTimeout(() => {
                            this.list.forEach(it => {
                                if (it.status !== 1) {
                                    it.status = 2;
                                }
                            });
                        }, 1500); // 延迟 1500 毫秒

                        // 如果还有抽奖次数，5 秒后复原
                        if (this.drawNum > 0) {
                            setTimeout(() => {
                                this.list.forEach(it => {
                                    it.status = 0;     // 恢复未翻开状态
                                    it.flipped = false;
                                });
                                // 洗牌，让下一轮随机
                                this.list.sort(() => Math.random() - 0.5);
                            }, 5000); // 延迟 5 秒
                        }
                    }, 300); // 动画持续时间
                });
            },
            async drawRecord() {
                await Fetch('/shard_lucky_draw/get_draw_record', { }).then((r) => {
                    this.showRecord = true;
                    this.drawRecordList = r.data;
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .basic_wrap {
        /*background: linear-gradient(135deg, #76B900, #A8E6CF, #FFFFFF)!important;*/
        background: #99c999;
        min-height: 100vh;
    }
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .red_top_bg {
        background: unset;
    }
    .wrap {
        padding: 10px;
    }
    .title {
        text-align: center;
    }
    #count {
        font-size: 16px;
        font-weight: 700;
        margin-left: 5px;
        color: #FF3030;
    }
    .box {
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* 一行 2 列 */
        gap: 15px; /* 卡片间距 */
        justify-items: center;
        width: 330px;
        margin: 0 auto;
    }

    .item {
        position: relative;
        width: 150px;
        height: 150px;
    }

    .card1,
    .card2 {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        text-align: center;
        transition: transform 0.4s;
    }

    .card1 {
        background: linear-gradient(135deg, #76b900, #0f2027, #2c5364);
        color: #fff;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        padding: 2px;
    }
    .card1 .prize-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .card2 {
        color: #fff;
        padding: 0 10px;
        transform: scaleX(0);
        background: linear-gradient(135deg, #76b900, #000000);
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    }

    .hide {
        transform: scaleX(0);
    }
    .show {
        transform: scaleX(1);
        font-weight: 700;
        color: #FFD700;
    }
    .show-result {
        transform: scaleX(1);
        opacity: 0.5;
    }
    /* 点击时的缩放弹跳效果 */
    .card-click {
        animation: clickScale 0.3s forwards;
    }
    @keyframes clickScale {
        0% { transform: scale(1); }
        50% { transform: scale(1.1); }
        100% { transform: scale(1); }
    }
    .illustrate {
        background: #000;
        margin: 10px 15px 0 15px;
        padding: 0 10px;
        font-size: 14px;
        text-align:center;
        color: #fff;
        border: 0.3rem solid #333;
        border-top: 0.48rem solid #333;
        // border-bottom: 0;
        border-radius: 0.2rem 0.2rem 0 0;

        div:nth-child(1) {
            background: url("~@/assets/images/illustrate.png") center no-repeat;
            width: 80%;
            height: 1.3rem;
            background-size: contain;
            position: relative;
            margin: 0 auto;
            font-size: 22px;
            margin-top: -0.46rem;
            line-height: 1.3rem;
            color: #ff2900;
        };
        div {
            p {
                line-height: 25px;
                margin-bottom: 10px
            }
        }
    }
    .prizeimg {
        height: 36px;
    }
    .prizeimg img {
        width: 36px;
        height: 36px;
    }

    .return-back1 {
        z-index: 999;
        width: auto;
        position: fixed;
        right: 0;
        top: 50px;
        padding: 10px 0;
        .back-right {
            width: auto;
            padding: 0 10px;
            height: 30px;
            border: 1px solid #fff;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0b9444;
            font-weight:bold;
            border-radius: 14px 0 0 14px;
            font-size: 15px;
        }
    }
</style>
